/* istanbul ignore file */
export enum NotificationSource {
  WEBSOCKET,
  PUSH,
}
